import { LogRange } from './LogCommands';

export type StepTaskData = {
  commands: {
    execution_duration: string;
    execution_string: string;
  }[];
  environment: string[];
  log_range: LogRange;
};

export type LogRangeTaskData = {
  commands: {
    execution_duration: string;
  }[];
  environment: string[];
  log_range: LogRange;
};

export type ExecutionPhaseType =
  | 'RUNNER_DETAILS'
  | 'SETUP'
  | 'MAIN'
  | 'AFTER_MAIN'
  | 'TEARDOWN';
